import React, { useState, useEffect } from "react";

const SearchChamerlean = () => {
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    // Pre-define as configurable so third-party script can redefine without throwing
    try {
      if (!("MYFI_COOKIE_CONSENT" in window)) {
        Object.defineProperty(window, "MYFI_COOKIE_CONSENT", {
          value: null,
          writable: true,
          configurable: true,
        });
      }
    } catch (_) {}

    const scriptUrl = "https://static.myfinance.com/embed/inlineMedia_core.js";
    const alreadyLoaded = Array.from(document.scripts).some((s) => s.src === scriptUrl);
    if (alreadyLoaded) {
      try {
        if (typeof window.initializeInline === "function") {
          window.initializeInline({ loadInlineCss: true });
        }
      } catch (err) {
        console.warn("MyFinance widget init:", err);
      }
      return;
    }

    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => {
      try {
        if (typeof window.initializeInline === "function") {
          window.initializeInline({ loadInlineCss: true });
        }
      } catch (err) {
        console.warn("MyFinance widget init:", err);
      }
    };
    script.onerror = () => {
      console.warn("MyFinance widget script failed to load");
    };
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, []);

  return (
    <div className="banner_content">
      <div className="custom-container">
        <div
          className="myFinance-widget"
          data-ad-id="ebe461ff-6e71-4484-bf1c-03e43e225e01"
          data-campaign="chameleon-comlink-zip-detected-providers"
        ></div>
      </div>
    </div>
  );
};

export default SearchChamerlean;
